const FIRST_PARTY_SOURCES = new Set([
	'confluence',
	'confluence-dc',
	'jira',
	'jira_dc',
	'jsm',
	'atlas',
	'compass',
	'trello',
	'help_aggregator',
	'bitbucket',
]);

export const is3pApp = (source: string): boolean => !FIRST_PARTY_SOURCES.has(source);
